$(document).ready(function(){

    $('.same-height').matchHeight();
    $('.same-height-all').matchHeight({byRow: false,});
    
    $('.progress .progress-bar').progressbar();

});

  